import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components/macro';

import { getParents, getUrl } from '../../utils/index';
import constantes from '../../resources/constantes.json';
import { snap } from '../../resources/constantes.json';
import InlineDialog, { useStateWithFocusManagement } from '../InlineDialog';
import { useTranslate } from '../../contexts/languageContext';
import CloseIcon from '../svg/close';
import NavList from './components/NavList';
import Dropdown from './components/Dropdown';
import ArrowInicio from '../svg/ArrowInicio';
import { themes } from '../../styles/themes';
import { responsive } from '../../resources/constantes.json';
import LinkWithTop from '../Links/LinkWithTop';
import { useMesa } from '../../contexts/viewContext';

/**
 * Menu de navegación que permite navegar por los distintos ámbitos de forma jerárquica mediante una
 * serie de dropdowns y una lista.
 */

const NavMenu = ({
  nomenclator,
  eleccion,
  page,
  ambito,
  className,
  parentLevel,
  esHistorico = false,
  children,
}) => {
  const t = useTranslate();
  const openButtonRef = useRef();
  const [isOpen, setIsOpen] = useStateWithFocusManagement(false, openButtonRef);

  return (
    <div className={className}>
      <OpenButton
        onClick={() => {
          !esHistorico && setIsOpen(!isOpen);
        }}
        ref={openButtonRef}
        aria-label={
          isOpen
            ? t('cerrarMenuNavegacionPorAmbitos')
            : t('abrirMenuNavegacionPorAmbitos')
        }
        style={{ padding: 0 }}
        page={page}
      >
        <FlexHome>
          <Text>{children}</Text>
          <div
            style={{
              width: '25px',
              aspectRatio: '1/1',
              backgroundColor: themes.tarjetasInicio.linkBtn,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '100%',
              color: '#FFF',
            }}
          >
            <ArrowInicio />
          </div>
        </FlexHome>
      </OpenButton>
      {isOpen && (
        <StyledInlineDialog
          onClose={e => {
            //setTimeout para que si le damos al OpenButton non se cierrre y se abra instantaneamente
            //TODO: comprobar que este truco funciona en todos los navegadores (Firefox y Chrome Ok).
            setTimeout(() => setIsOpen(false), 0);
          }}
        >
          <StyledNavMenuContent
            nomenclator={nomenclator}
            eleccion={eleccion}
            ambito={ambito}
            page={page}
            setIsOpen={setIsOpen}
            parentLevel={parentLevel}
          />
        </StyledInlineDialog>
      )}
      {snap && (
        <StyledNavMenuContent
          nomenclator={nomenclator}
          eleccion={eleccion}
          ambito={ambito}
          page={page}
          setIsOpen={setIsOpen}
          parentLevel={parentLevel}
          css="display: none;"
        />
      )}
    </div>
  );
};

const FlexHome = styled.span`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  column-gap: 20px;
  line-height: 0;
  cursor: pointer;
  margin-left: auto;
  color: ${themes.inicio.base};
`;

const Text = styled.span`
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 1;
  text-align: left;
  @media print {
    color: #1c4183;
  }
  @media (max-width: 1400px) {
    font-size: 1.2rem;
  }
`;

const NavMenuContent = withRouter(function NavMenuContent({
  ambito,
  className = '',
  eleccion,
  history,
  nomenclator,
  page,
  parentLevel,
  setIsOpen,
}) {
  const [selectedId, setSelectedId] = useState(ambito.i);
  const [zonaOComuna, setZonaOComuna] = useState(null);
  const [localMesa, setLocalMesa] = useState(null);
  const t = useTranslate();
  const levelText = {
    [constantes.level.departamento]: t('departamentosDC'),
    [constantes.level.municipio]: t('municipios'),
    [constantes.level.zona]: t('zonas'),
    [constantes.level.comuna]: t('comunas'),
    [constantes.level.puesto]: t('puestos'),
    [constantes.level.mesa]: t('mesas'),
  };
  const { mesa, setMesa } = useMesa();
  const isMesa = selectedId.length > 11;
  const ambitos = nomenclator.ambitos[eleccion];
  // eslint-disable-next-line no-debugger
  // debugger;
  const genealogy = [
    ...getParents(selectedId, eleccion, nomenclator, parentLevel).reverse(),
    selectedId,
  ];
  const root = genealogy[0];
  const dropdownGenealogy =
    !isMesa && ambitos[selectedId].l === constantes.level.puesto
      ? genealogy
      : genealogy.slice(1);
  let dropdownIds = [...dropdownGenealogy];
  if (
    (!isMesa && !ambitos[selectedId].h) ||
    ambitos[selectedId].h.length === 0 ||
    (page === 'inicio' && ambitos[selectedId].l > 2)
  ) {
    if (!isMesa && ambitos[selectedId].l !== constantes.level.puesto) {
      dropdownIds = dropdownIds.slice(0, -1);
    }
  }

  const onSelection = id => {
    const ambito = ambitos[id];
    if (
      ambito.l === constantes.level.comuna ||
      ambito.l === constantes.level.zona
    ) {
      window.zonaOComuna = ambito.l === constantes.level.comuna ? 1 : 0;
    }
    setSelectedId(id);
  };

  const childs = ambitos[root].h.map(id => ambitos[id]);
  return (
    <div className={className}>
      <RowTitle>
        <Title>
          <TitleButton onClick={() => onSelection(root)}>
            {ambitos[root].n}
          </TitleButton>
        </Title>
        <CloseButton onClick={() => setIsOpen(false)} aria-label={t('cerrar')}>
          <CloseIcon
            width={25}
            height={25}
            fill="#FFF"
            css={`
              vertical-align: top;
            `}
          />
        </CloseButton>
      </RowTitle>
      <Divider />
      <Panels>
        <LeftPane>
          <SubTitle>{`${levelText[constantes.level.departamento]}`}</SubTitle>
          <NavList
            childs={childs}
            eleccion={eleccion}
            nomenclator={nomenclator}
            onSelection={onSelection}
            selectedId={genealogy[1] || null}
            page={page}
            parentLevel={parentLevel}
          />
        </LeftPane>
        <RightPane>
          <RightWrapper>
            <Row>
              {dropdownIds.length === 0 && (
                <TextoInformativo>
                  {t('seleccioneUnDepartamento')}
                </TextoInformativo>
              )}
            </Row>
            <StyledDropdownGroup
              ambitos={ambitos}
              dropdownIds={dropdownIds}
              eleccion={eleccion}
              genealogy={dropdownGenealogy}
              history={history}
              levelText={levelText}
              nomenclator={nomenclator}
              onSelection={onSelection}
              useMesa={useMesa}
              page={page}
              parentLevel={parentLevel}
              selectedAmbito={ambitos[selectedId]}
              selectedLevel={mesa ? constantes.level.mesa : ambito.l}
              selectedMesa={mesa ? mesa : undefined}
              localMesa={localMesa}
              setLocalMesa={setLocalMesa}
              variant="desktop"
              mesa={mesa}
            />
          </RightWrapper>
        </RightPane>
      </Panels>
      <RowButtonLink>
        <ButtonLink
          to={getUrl({
            id: selectedId,
            eleccion,
            nomenclator,
            page,
            parentLevel,
            mesa: localMesa,
          })}
          onClick={() => {
            setIsOpen(false);
            setMesa(localMesa);
          }}
        >
          {t('navegar')}
        </ButtonLink>
      </RowButtonLink>
    </div>
  );
});

export const NavMenuMobile = withRouter(
  ({
    ambito,
    className,
    eleccion,
    history,
    nomenclator,
    page,
    parentLevel,
    setIsOpen,
  }) => {
    const t = useTranslate();
    const levelText = {
      [constantes.level.departamento]: t('departamentosDC'),
      [constantes.level.municipio]: t('municipios'),
      [constantes.level.zona]: t('zonas'),
      [constantes.level.comuna]: t('comunas'),
      [constantes.level.puesto]: t('puestos'),
      [constantes.level.mesa]: t('mesas'),
    };

    const [selectedId, setSelectedId] = useState(ambito.i);
    const ambitos = nomenclator.ambitos[eleccion];
    const genealogy = [
      ...getParents(selectedId, eleccion, nomenclator, parentLevel).reverse(),
      selectedId,
    ];
    const root = genealogy[0];
    let dropdownIds = genealogy;
    if (
      !ambitos[selectedId].h ||
      ambitos[selectedId].h.length === 0 ||
      (page === 'inicio' && ambitos[selectedId].l > 2)
    ) {
      dropdownIds = dropdownIds.slice(0, -1);
    }
    const isMesaSelected = false;
    const idWithMesa = '';
    return (
      <MobileContainer className={className}>
        <SearchContent>
          <Row>
            <Title>
              <button
                css={`
                  color: inherit;
                  text-decoration: underline;
                  border: none;
                  background: transparent;
                  &.focus-visible {
                    text-decoration: underline !important;
                    outline: none !important;
                  }
                `}
                onClick={() => setSelectedId(root)}
              >
                {ambitos[root].n}
              </button>
            </Title>
          </Row>
          <Divider />
          <DropdownsContainer>
            <DropdownGroup
              ambitos={ambitos}
              dropdownIds={dropdownIds}
              eleccion={eleccion}
              genealogy={genealogy}
              levelText={levelText}
              nomenclator={nomenclator}
              onSelection={setSelectedId}
              page={page}
              parentLevel={parentLevel}
              selectedAmbito={ambitos[selectedId]}
              selectedLevel={
                isMesaSelected ? constantes.level.mesa : ambitos[selectedId].l
              }
              selectedMesa={isMesaSelected ? idWithMesa.toString() : undefined}
              variant="mobile"
            />
          </DropdownsContainer>
        </SearchContent>
        <ConfirmButtonWrapper>
          <RowButtonLink>
            <ButtonLink
              to={getUrl({
                id: selectedId,
                eleccion,
                nomenclator,
                page,
                parentLevel,
              })}
              onClick={() => {
                setIsOpen(false);
              }}
            >
              {t('navegar')}
            </ButtonLink>
          </RowButtonLink>
        </ConfirmButtonWrapper>
      </MobileContainer>
    );
  }
);
const DropdownsContainer = styled.div`
  overflow: auto;
  padding-right: 4rem;
`;
const RowTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RowButtonLink = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding-top: 3rem;
  @media (max-width: ${responsive.tablet}px) {
    justify-content: center;
  }
`;
const ButtonLink = styled(LinkWithTop)`
  display: flex;
  width: 19rem;
  padding: 2rem 3rem;
  justify-content: center;
  align-items: center;
  gap: 1.4rem;
  border-radius: 100px;
  background: #215ccc;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  &:hover {
    text-decoration: none;
    background: rgb(28, 40, 61, 0.5);
  }
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
  }
`;

const MobileContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: 3rem;
  justify-content: space-between;
  flex-grow: 1;
  color: #164192;

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    padding: 2rem;
  }
`;

const SearchContent = styled.div`
  overflow: auto;
  flex-grow: 1;
`;

const ConfirmButtonWrapper = styled.div``;

const DropdownGroup = ({
  genealogy,
  dropdownIds,
  ambitos,
  levelText,
  nomenclator,
  eleccion,
  page,
  selectedAmbito,
  onSelection,
  useMesa,
  variant,
  localMesa,
  setLocalMesa,
  className,
  parentLevel,
}) =>
  dropdownIds.map((id, index) => {
    let childs = ambitos[id].h.map(id => ambitos[id]);
    const areChildrenMesas = ambitos[id].l === constantes.level.puesto;
    childs = areChildrenMesas
      ? Array(ambitos[id].m || 0)
          .fill()
          .map((_, index) => ({
            i: ambitos[id].i, //le ponemos el index del puesto
            n: `MESA ${index + 1}`,
            c: `${ambitos[id].c}${(index + 1).toString().padStart(6, '0')}`,
            s: '',
            m: 0,
            l: constantes.level.mesa,
            h: [],
            p: [id],
          }))
      : ambitos[id].h.map(id => ambitos[id]);
    const level = childs && childs[0] && childs[0].l;
    let comuna = [];
    if (level === constantes.level.zona) {
      comuna = childs.filter(child => child.l === constantes.level.comuna);
    }
    childs = childs.filter(child => child.l === level);

    const hasSelectedItem =
      index !== genealogy.length - 1 && selectedAmbito.l >= ambitos[id].l;
    const selectedItem = hasSelectedItem && ambitos[genealogy[index + 1]];
    const isLast = index === dropdownIds.length - 1;

    return (
      <span key={id + Math.random()}>
        {comuna.length > 0 && (
          <DropdownGroupRow className={className}>
            <Row>
              <StyledDropdown
                items={comuna}
                defaultButtonText={`${levelText[constantes.level.comuna]} (${
                  comuna.length
                })`}
                nomenclator={nomenclator}
                eleccion={eleccion}
                level={level}
                defaultSelectedId={selectedItem.i}
                hasSelectedItem={hasSelectedItem}
                openOnMount={isLast && variant === 'desktop'}
                useMesa={useMesa}
                selectedMesa={localMesa}
                setLocalMesa={setLocalMesa}
                onSelection={onSelection}
                page={page}
                variant={variant}
                parentLevel={parentLevel}
              />
            </Row>
            {!isLast && (
              <Row>
                <Divider width="100%" />
              </Row>
            )}
          </DropdownGroupRow>
        )}
        {childs.length > 0 && level !== 2 && (
          <DropdownGroupRow className={className}>
            <Row>
              <StyledDropdown
                items={childs}
                defaultButtonText={`${levelText[level]} (${childs.length})`}
                nomenclator={nomenclator}
                level={level}
                eleccion={eleccion}
                defaultSelectedId={selectedItem.i}
                hasSelectedItem={hasSelectedItem}
                openOnMount={isLast && variant === 'desktop'}
                onSelection={onSelection}
                selectedMesa={localMesa}
                setLocalMesa={setLocalMesa}
                page={page}
                variant={variant}
                parentLevel={parentLevel}
              />
            </Row>
            {!isLast && (
              <Row>
                <Divider width="100%" />
              </Row>
            )}
          </DropdownGroupRow>
        )}
      </span>
    );
  });

const StyledNavMenu = styled(NavMenu)`
  position: relative;
`;
export default StyledNavMenu;

const Row = styled.div`
  display: flex;
  width: 100%;
`;

const DropdownGroupRow = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  align-items: flex-start;
  align-content: flex-start;
`;

const StyledDropdownGroup = styled(DropdownGroup)`
  ${Row} {
    padding-right: 3rem;
  }
`;

const OpenButton = styled.button`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  padding: 14px;
  padding-left: 10px;
  border-radius: 4px;
  vertical-align: middle;
  transition-duration: 200ms;
  &:hover {
    scale: 1.05;
  }
`;
const StyledInlineDialog = styled(InlineDialog)`
  color: #164192;
  position: absolute;
  width: 1008px;
  height: 628px;
  border-radius: 30px;
  background: #f5f8fd;
  box-shadow: 5px 15px 20px 0 rgba(0, 0, 0, 0.2);
  margin: 0;
  padding: 0px;
  z-index: 1000;
  margin-top: 15px;
  top: 44px;
  padding: 4rem;
  box-sizing: border-box;
  @media (max-width: ${responsive.maxWidth.desktop}px) {
    width: 72vw;
    height: 84vh;
  }
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    width: 664px;
    height: 80vh;
  }
`;

const StyledNavMenuContent = styled(NavMenuContent)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  :before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
    border-bottom: 40px solid #f5f8fd;
    top: -60px;
    left: 16px;
  }
`;

const CloseButton = styled.button`
  width: 50px;
  height: 50px;
  padding: 10px;
  background: #215ccc;
  border: none;
  justify-self: flex-end;
  border-radius: 100px;
`;

const Panels = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  flex-grow: 1;
  overflow: auto;
`;

const LeftPane = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const RightPane = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  flex-flow: row wrap;
  align-items: flex-start;
  align-content: flex-start;
  width: auto;
  overflow: auto;
  background: white;
  padding: 1rem 2rem;
  border-radius: 20px;
`;

const RightWrapper = styled.div`
  overflow: auto;
  height: 100%;
  width: 100%;
`;

const Title = styled.div`
  text-transform: uppercase;
  font-size: 3.2rem;
  font-weight: 700;
  @media (max-width: 1400px) {
    font-size: 1.6rem;
  }
`;

const SubTitle = styled(Title)`
  font-size: 2.8rem;
  padding: 1rem 0 2rem 0;
`;

const TitleButton = styled.button`
  text-decoration: underline;
  color: inherit;
  background: inherit;
  &:hover {
    color: #215ccc;
  }
`;

const Divider = styled.hr`
  border: none;
  height: 2px;
  margin: 0;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.12);
  margin: 1.4rem 0;
`;

const TextoInformativo = styled.p`
  font-size: 14px;
  font-style: italic;
  line-height: 1.25;
  padding-top: 20px;
  font-weight: bold;
`;
const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;
